import React from "react";
import { useParams } from "react-router-dom";
import { useCollection } from "../collectionServices";

import ManageMediaAccess from "../../common/ManageMediaAccess";
import PanelLoadingIndicator from "../../../components/PanelLoadingIndicator";

const ManageCollectionAccess = () => {
  const { id } = useParams();
  const collection = useCollection(id);

  if (collection.isLoading) {
    return <PanelLoadingIndicator />;
  }

  return <ManageMediaAccess media={collection.data} />;
};

export default ManageCollectionAccess;
